import React from "react";
import "./vendorform.css"

const VendorOnboardingConfirmModal = ({
  show,
  onClose,
  onConfirm,
  loading,
//   vendorName,
//   vendorGst,
//   vendorPan,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div
      className="vendor-confirm-overlay"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !loading) {
          onClose();
        }
      }}
    >
      <div
        className="vendor-confirm-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="vendor-confirm-title"
      >
        {/* HEADER */}

        <div className="vendor-confirm-header">
          {/* <div className="vendor-confirm-icon">
            ?
          </div> */}

          <div>
            <h5 id="vendor-confirm-title">
              Confirm Vendor Submission
            </h5>

            <p>
              Please review the vendor details before submitting.
            </p>
          </div>

          <button
            type="button"
            className="vendor-confirm-close"
            onClick={onClose}
            disabled={loading}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* BODY */}

        <div className="vendor-confirm-body">
          <div className="vendor-confirm-message">
            Are you sure you want to submit this vendor?
          </div>

        </div>

        {/* FOOTER */}

        <div className="vendor-confirm-footer">
          <button
            type="button"
            className="vendor-confirm-cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            type="button"
            className="vendor-confirm-submit-btn"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="vendor-confirm-spinner"
                  aria-hidden="true"
                />
                Submitting...
              </>
            ) : (
              "Confirm & Submit"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VendorOnboardingConfirmModal;
